module.exports = __webpack_public_path__ + "static/media/resume.1994faa3.svg";